import React, { useEffect, useState } from 'react'
import YourInformationView from './components/YourInformationView'
import Error from 'shared/components/Error'
import { withTranslation } from 'react-i18next'
import { addToGoogleDataLayer } from 'shared/const/utls.js'

const YourInformation = ({ i18n }) => {
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    try {
      addToGoogleDataLayer('your-info', 'Pay a Fee for Defaulted Fines', i18n.language)
      window.scrollTo(0, 0)
    } catch (e) {
      console.log(e)
    }
  }, [])

  return isError ? <Error /> : <YourInformationView setIsError={setIsError} />
}

export default withTranslation('common')(YourInformation)
